// @ts-strict-ignore
import {
  AfterViewInit,
  Component, Input,
  OnInit,
} from '@angular/core';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import { LMErrorUtilService } from '@services/utils/lm-error-util.service';

@Component({
  selector: 'lm-application-menu-asofdate',
  standalone: false,
  template: `
    <label
        soho-label
        [required]="true"
        for="date"
    >{{'CreateReportAsOfDateLabel' | translate}}</label>
    <input
        name="date"
        soho-datepicker
        data-automation-id="lm-as-of-date-field"
        [options]="pickerOptions"
        [(ngModel)]="model.value"
        (change)="onChange($event)"
        (paste)="onPaste($event)"
        attr.aria-label="{{ 'CreateReportAsOfDateLabel' | translate }}"
    />
  `,
  providers: [ LMRouteComponentService ]
})
export class LMApplicationMenuAsOfDateDialogComponent implements OnInit, AfterViewInit {
  constructor(private lmErrorUtilService: LMErrorUtilService) {}

  public pickerOptions: SohoDatePickerOptions = {
    mode: 'standard',
    dateFormat: Soho.Locale.calendar().dateFormat.short,
    showMonthYearPicker: true
  };
  @Input() asOfDate: string;
  public model = {
    value: ''
  };

  ngOnInit() {
    if (this.asOfDate) {
      this.model.value = this.asOfDate;
    }
  }

  ngAfterViewInit() {
    // no op
  }

  onChange(event) {
    this.asOfDate = this.model.value;
  }

  public getDate() {
    return this.asOfDate;
  }

  onPaste(event: ClipboardEvent) {
    this.asOfDate =  event.clipboardData?.getData('text') || '';
  }

}
